import { Route, Routes } from 'react-router-dom'
import { Navigate } from 'react-router'
import { PersonalRoutes } from 'pages/settings/pages/personal/route/type'
import { AccountRouter } from 'pages/settings/pages/personal/pages/account'
import { AuthorizedAppsRouter } from 'pages/settings/pages/personal/pages/authorizedApps'

export const PersonalRouter = () => {
  return (
    <Routes>
      <Route path={`/${PersonalRoutes.settings}/*`} element={<AccountRouter />} />
      <Route path={`/${PersonalRoutes.authorizedApps}`} element={<AuthorizedAppsRouter />} />
      <Route
        index
        element={<Navigate to={`${PersonalRoutes.settings}/${PersonalRoutes.profile}`} replace />}
      />
    </Routes>
  )
}
